import { SUPPORTED_LOCALES } from 'constants/locales';
import actions from 'state/constants';
import initialState from 'state/initialState';
import { DIGITAL_WALLETS } from 'utils/Money/constants';
import Settings from 'utils/Settings';

const fetchPaymentSettigsReducer = state => ({
  ...state,
  paymentSettings: {
    ...state.paymentSettings,
    isPaymentSettingBegin: false,
  },
});

const fetchedPaymentSettigsReducer = (state, action) => {
  // Add PayPal and AmazonPay for US, not available yet on digital wallets enum
  const usDigitaWallets =
    Settings.currentLocale == SUPPORTED_LOCALES.EN_US
      ? [DIGITAL_WALLETS.AMAZON_PAY, DIGITAL_WALLETS.PAY_PAL]
      : [];

  return {
    ...state,
    paymentSettings: {
      ...state.paymentSettings,
      ...action?.payload?.paymentSettings,
      supportedDigitalWallets: [
        ...action?.payload?.paymentSettings.supportedDigitalWallets,
        ...usDigitaWallets,
      ],
      isPaymentSettingBegin: true,
      errorMessage: action?.payload?.error || null,
    },
  };
};

export const reducer = (state = initialState.shop, action) => {
  switch (action.type) {
    case actions.FETCH_PAYMENT_SETTINGS_REQUEST:
      return fetchPaymentSettigsReducer(state, action);
    case actions.FETCH_PAYMENT_SETTINGS_SUCCESS:
    case actions.FETCH_PAYMENT_SETTINGS_FAILURE:
      return fetchedPaymentSettigsReducer(state, action);

    default:
      return state;
  }
};

export default reducer;
